import Vue from 'vue'
import VueMapbox from 'vue-mapbox'
import Mapbox from 'mapbox-gl'
import 'mapbox-gl/src/css/mapbox-gl.css'

Vue.use(VueMapbox, { mapboxgl: Mapbox })
